import PrivacyPolicyComponent from '@/components/pages/Terms/components/PrivacyPolicy'

// Components
import LegalDocument from '@/components/pages/HelpCenter/components/LegalDocument'
import HelpHead from '@/components/pages/HelpCenter/components/HelpHead'

// Libs
import { HELP_PAGE_KEY } from '@/api/fetchHelpPage'
import { articleDescription } from '@/components/pages/HelpCenter/methods'
import { getLegalPageProps, LegalPageProps } from '@/components/pages/HelpCenter/methods/legalPage'

// Constants
import { ROUTE_PATH } from '@/constants/routePath'

// 內容由後台「條款與政策」提供；還沒指定時顯示原本內建在語系檔的版本
const PrivacyPolicy = ({ pageProps }: { pageProps: LegalPageProps }) => {
  const { article } = pageProps
  if (!article) return <PrivacyPolicyComponent />

  return (
    <>
      <HelpHead
        standalone
        title={article.title}
        description={articleDescription(article.summary, article.content)}
        canonicalPath={ROUTE_PATH.PRIVACY_POLICY}
      />
      <LegalDocument article={article} />
    </>
  )
}

export const getServerSideProps = getLegalPageProps(HELP_PAGE_KEY.PRIVACY_POLICY)

export default PrivacyPolicy
